// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.R58TGY {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.UIn1a0 {
  font-family: var(--font-family-base);
  font-weight: var(--type-title-md-font-weight);
  font-size: var(--type-title-md-font-size);
  line-height: var(--type-title-md-line-height);
  color: var(--public-layout-text-color);
  margin: 0;
  margin-top: -24px;
  text-align: center;
}

.lkv27T {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  margin-top: 40px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--card-box-shadow);
}

.sSTc6k {
  border-top: 4px solid var(--surface-primary-medium);
}

.trqVL_ {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  font-size: var(--type-paragraph-lg-font-size);
  line-height: var(--type-paragraph-lg-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.cnIewR {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2);
  width: 100%;
}

.MjP3dN {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: var(--surface-neutral-subtle);
  border-radius: var(--spacing-2);
  flex-shrink: 0;
}

.SraRsT {
  font-family: var(--font-family-base);
  font-weight: var(--type-title-md-font-weight);
  font-size: var(--type-title-md-font-size);
  line-height: var(--type-title-md-line-height);
  color: var(--surface-primary-medium);
}

.IDn2yi {
  font-family: var(--font-family-base);
  font-weight: var(--type-paragraph-sm-regular-font-weight);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  flex: 1;
}

.gVSymb {
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
  width: 100%;
  border: none;
  margin: 0;
}

.UFlVOI {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-1);
  padding: var(--button-padding-lg);
  width: 100%;
  background-color: var(--surface-primary-medium);
  border: none;
  border-radius: var(--button-border-radius);
  cursor: pointer;
  font-family: var(--font-family-base);
  font-weight: var(--type-label-lg-font-weight);
  font-size: var(--type-label-lg-font-size);
  line-height: var(--type-label-lg-line-height);
  color: var(--text-neutral-white);
  text-align: center;
  box-shadow: var(--button-box-shadow);
  transition: background-color 0.2s ease;
}

.UFlVOI:hover {
  background-color: var(--surface-primary-strong);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/LoginResetPassword/LoginResetPassword.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yCAAyC;EACzC,6CAA6C;EAC7C,sCAAsC;EACtC,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;EAC9C,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yCAAyC;EACzC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,6CAA6C;EAC7C,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,WAAW;EACX,+CAA+C;EAC/C,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,oCAAoC;EACpC,6CAA6C;EAC7C,yCAAyC;EACzC,6CAA6C;EAC7C,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-title-md-font-weight);\n  font-size: var(--type-title-md-font-size);\n  line-height: var(--type-title-md-line-height);\n  color: var(--public-layout-text-color);\n  margin: 0;\n  margin-top: -24px;\n  text-align: center;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  margin-top: 40px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--card-box-shadow);\n}\n\n.cardWithBorder {\n  border-top: 4px solid var(--surface-primary-medium);\n}\n\n.headerText {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  font-size: var(--type-paragraph-lg-font-size);\n  line-height: var(--type-paragraph-lg-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.stepContainer {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2);\n  width: 100%;\n}\n\n.stepNumber {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background-color: var(--surface-neutral-subtle);\n  border-radius: var(--spacing-2);\n  flex-shrink: 0;\n}\n\n.stepNumberText {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-title-md-font-weight);\n  font-size: var(--type-title-md-font-size);\n  line-height: var(--type-title-md-line-height);\n  color: var(--surface-primary-medium);\n}\n\n.stepDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--type-paragraph-sm-regular-font-weight);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  flex: 1;\n}\n\n.divider {\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n  width: 100%;\n  border: none;\n  margin: 0;\n}\n\n.button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-1);\n  padding: var(--button-padding-lg);\n  width: 100%;\n  background-color: var(--surface-primary-medium);\n  border: none;\n  border-radius: var(--button-border-radius);\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-weight: var(--type-label-lg-font-weight);\n  font-size: var(--type-label-lg-font-size);\n  line-height: var(--type-label-lg-line-height);\n  color: var(--text-neutral-white);\n  text-align: center;\n  box-shadow: var(--button-box-shadow);\n  transition: background-color 0.2s ease;\n}\n\n.button:hover {\n  background-color: var(--surface-primary-strong);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `R58TGY`,
	"title": `UIn1a0`,
	"card": `lkv27T`,
	"cardWithBorder": `sSTc6k`,
	"headerText": `trqVL_`,
	"stepContainer": `cnIewR`,
	"stepNumber": `MjP3dN`,
	"stepNumberText": `SraRsT`,
	"stepDescription": `IDn2yi`,
	"divider": `gVSymb`,
	"button": `UFlVOI`
};
module.exports = ___CSS_LOADER_EXPORT___;
